<template>
  <div class="p-grid">
    <div class="p-col-12">
      <br />
      

      <h4>List of Quotation Attachemts</h4>

      <Toolbar class="p-mb-4">
        <template slot="left">
          <Button
            label="New Attachment"
            icon="pi pi-plus"
            class="p-button-success p-mr-2"
            @click="newAttachment"
          />
        </template>

        <template slot="right">
          <span class="p-input-icon-left">
            <i class="pi pi-search" />
            <InputText
              v-model="filters['global']"
              placeholder="Global Search"
              style="margin-right: 0.5em"
              @input="updateSearch"
            />
          </span>
        </template>
      </Toolbar>

      <AttachmentTable
        v-if="Array.isArray(attachemts)"
        :key="attachmentsKey"
        :attachemts="attachemts"
        :filters="filters"
        :loading="loading"
        @edit="editAttachment"
        @delete="deleteAttachment"
      />

      <!-- Component to Create & Edit an attachments -->
      <AttachmentForm
        :attachment="attachment"
        :key="attachmentKey"
        :quotation="quotation"
        :submitted="submitted"
        :attachmentForm="attachmentForm"
        @close="hideDialog"
        @saved="savedAttachment"
      />

    </div>
  </div>
</template>

<script>
import AttachmentService from "@/service/AttachmentService";
import QuotationService from "@/service/QuotationService";

import AttachmentTable from './attachmentsTable'
import AttachmentForm from '@/mbp/universalComponents/attachment/attachmentForm'

export default {
  components: {
    AttachmentTable,
    AttachmentForm
  },
  data: () => ({
    quotationService: new QuotationService,
    attachmentService: new AttachmentService(),
    filters: {},
    attachmentsKey1: 0,
    attachmentKey1: 0,
    file: {},
    attachment: {},
    submitted: false,
    attachmentForm: false,
    requesting: false
  }),
  computed: {
    attachmentsKey: {
      set(val) {
        this.attachmentsKey1++
      },
      get() {
        return 'attachmentTable' + this.attachmentsKey1.toString()
      }
    },
    attachmentKey: {
      set(val) {
        this.attachmentKey1++
      },
      get() {
        return 'attachmentForm' + this.attachmentKey1.toString()
      }
    },
    loading() {
      if (this.attachemts && this.attachemts[0]) {
        return false
      } else {
        if (this.requesting) {
          return true
        } else {
          return false
        }
      }
    },
    attachemts() {
      return this.$store.getters['quotations/getQuoteAttachmentsForTab']
    },
    quotation() {
      return this.$store.getters['quotations/getQuoteForTabs']
    }
  },
  watch: {
    attachmentForm(val) {
      this.attachmentKey++
    },
    attachemts(val) {
      if (val && val[0]) {
        this.attachmentsKey++
      }
    },
    quotation(val) {
      if (val && val[0]) {
        this.attachmentKey++
      }
    }
  },
  methods: {
    getQuotationAttachments(quoteVerId) {
      this.requesting = true
      this.quotationService
        .getQuotationAttachments(quoteVerId)
        .then(data => {
          this.requesting = false
          this.$store.dispatch('quotations/setQuoteAttachmentsForTab', data)
        })
        .catch(err => {
          this.requesting = false
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting quotation attachments",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "quotationattachments/{quoteVerId}"'
          })
        })
    },
    editAttachment(attachment) {
      this.file = {}
      this.attachment = {...attachment}
      this.updatedBy = this.$store.getters['auth/getMyProfile']
      this.submitted = false;
      this.attachmentForm = true;
    },
    deleteAttachment(attachment) {

    },
    savedAttachment({ file, attachment }) {
      
      this.getQuotationAttachments(this.quotation.quoteVerId)  //should be replaced to this.$route.params.quoteVerId
  
      this.attachmentForm = false
      this.attachment = {}
    },
    hideDialog() {
      this.attachmentForm = false
      this.submitted = false;
    },
    newAttachment() {
      this.file = {}
      this.attachment = {}
      this.submitted = false;
      this.attachmentForm = true;
    },
    updateSearch(e) {
      this.$router.push({ query: { search: e } });
    }
  }
}
</script>

<style>

</style>